import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { HashRouter, Routes, Route } from "react-router-dom";
import PdfReader from './routes/pdfreader';
import EpubReader from './routes/epubreader';
import ShortReader from './routes/shortreader';
import MissingPage from './routes/missingpage';
import MainPage from './routes/mainpage'
import InfoPage from './routes/infopage'


ReactDOM.render(
  <HashRouter >
    <Routes>
      <Route path="/" element={<App />}>
        <Route path="pdfreader" element={<PdfReader />} />
        <Route path="epubreader" element={<EpubReader />} />
        <Route path="shortreader" element={<ShortReader />} />
        <Route path="infopage" element={<InfoPage />} />
        <Route exact path="" element={<MainPage />} />
        <Route path="*" element={<MissingPage />} />
      </Route>
    </Routes>
  </HashRouter >,
  document.getElementById('root')
);

